import { jsx as _jsx } from "react/jsx-runtime";
import * as lucideIcons from "lucide-react";
import { twMerge } from "tailwind-merge";
export const { icons } = lucideIcons;
function Lucide(props) {
    const { icon, className, ...computedProps } = props;
    const Component = icons[props.icon];
    return (_jsx(Component, { ...computedProps, className: twMerge(["stroke-1.5 w-5 h-5", props.className]) }));
}
export default Lucide;